import IndividualGroupProfile from "../../../shared-screens/views/individualGroupProfile/individualGroupProfile";

const GroupProfile = () => {
  return <IndividualGroupProfile />;
};

export default GroupProfile;
